import React, { useState, useEffect, useRef } from 'react';
import './VoteFilters.css';
import filterConfig from './filterConfig.json';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const VoteFilters = ({ onFilterChange, activeFilters }) => {
  const [filters, setFilters] = useState({
    all: true,
    recentlyAdded: false,
    expiringSoon: false,
    isFaceRequired: false,
    isLocation: false,
    isNotVoted: false,
    mostPopular: false,
    mostUnanimous: false,
    mostDivided: false,
    mostLiked: false,
    mostCommented: false
  });

  // Ensure "All" is always the default when component mounts
  useEffect(() => {
    if (activeFilters && !Object.values(activeFilters).some(v => v === true)) {
      const defaultFilters = {
        all: true,
        recentlyAdded: false,
        expiringSoon: false,
        isFaceRequired: false,
        isLocation: false,
        isNotVoted: false,
        mostPopular: false,
        mostUnanimous: false,
        mostDivided: false,
        mostLiked: false,
        mostCommented: false
      };
      setFilters(defaultFilters);
      onFilterChange(defaultFilters);
    }
  }, [activeFilters, onFilterChange]);

  const filterOptions = filterConfig.filterOptions;

  const handleFilterClick = (filterKey) => {
    const newFilters = {
      all: false,
      recentlyAdded: false,
      expiringSoon: false,
      isFaceRequired: false,
      isLocation: false,
      isNotVoted: false,
      mostPopular: false,
      mostUnanimous: false,
      mostDivided: false,
      mostLiked: false,
      mostCommented: false
    };

    // Only the clicked filter should be true
    newFilters[filterKey] = true;

    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const scrollRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);

  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 2); // 2px buffer
    }
  };

  useEffect(() => {
    handleScroll();
    window.addEventListener('resize', handleScroll);
    return () => window.removeEventListener('resize', handleScroll);
  }, []);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  return (
    <div className="vote-filters-container">
      {showLeftArrow && (
        <button className="scroll-arrow left-arrow" onClick={scrollLeft} aria-label="Scroll left">
          <ChevronLeftIcon />
        </button>
      )}
      <div className="vote-filters-scroll" ref={scrollRef} onScroll={handleScroll}>
        {filterOptions.map((option) => (
          <button
            key={option.key}
            className={`vote-filter-button ${filters[option.key] ? 'active' : ''}`}
            onClick={() => handleFilterClick(option.key)}
            aria-pressed={filters[option.key]}
            aria-label={`Filter by ${option.label}`}
            title={option.description}
          >
            <span className="filter-icon" aria-hidden="true">{option.icon}</span>
            <span className="filter-label">{option.label}</span>
          </button>
        ))}
      </div>
      {showRightArrow && (
        <button className="scroll-arrow right-arrow" onClick={scrollRight} aria-label="Scroll right">
          <ChevronRightIcon />
        </button>
      )}
    </div>
  );
};

export default VoteFilters;
